/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import ActionButtons from '../../actionbuttons';
import { ReactComponent as ChevronDownCircle } from 'assets/icons/chevron-down-circle.svg'
import { ReactComponent as ChevronUpCircle } from 'assets/icons/chevron-up-circle.svg'

// styles
import injectSheet from 'react-jss';
import styles from './configv2controller_styles';


/* ========== ~~~~~~~~~~ EXPANDABLE SECTION - CONFIG CONTROLLER ~~~~~~~~~~ ========== */
const ConfigV2Controller = (props) => {
  const {
    icon,
    title,
    handleCancel,
    handleSave,
    handleToggle,
    isOpened,
    isChanged,
    isLoading,
    cancelTitle,
    saveTitle,
    isProcessing,
    disableSave,
    disabled,
    alwaysShowActionButtons,
    hideDefaultActionButtons, // when we hide save, cancel buttons and just allow user to toggle
    actionButtons
  } = props;

  return (
    <div className={`configv2controller ${props.classes.configv2controller} ${props.className} header controls opened-${isOpened} disabled-${disabled}`} 
    onClick={() => {
      handleToggle()
    }}>
      <div className={'header'}>
        {icon}
        <h2 className='title'>
          {title}
        </h2>
      </div>

      <div className={'actions'}>
        {((isOpened || alwaysShowActionButtons) && actionButtons) && 
          <div className='actionButtons'>
            {actionButtons}
          </div>
        }
        {isOpened && !actionButtons  && 
          <div className={`actionbuttons`} onClick={e => e.stopPropagation()}>
            <ActionButtons
              handleCancel={handleCancel}
              handleSave={handleSave}
              isChanged={isChanged}
              isLoading={isLoading}
              cancelTitle={cancelTitle}
              saveTitle={saveTitle}
              isProcessing={isProcessing}
              disableSave={disableSave}
            />
          </div>
        }
        <div className={'toggleicons'}>
          { !isOpened ? <ChevronDownCircle className={'toggle-down'} /> : <ChevronUpCircle className={'toggle-up'} /> }
        </div>
      </div>
    </div>
  )
};


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ConfigV2Controller);
